<template>
    <div class="dashboard-welcome">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="panel panel-primary panel-welcome">
                <div class="panel-heading">
                    <h3 class="panel-title" align="center">{{ $t("message.welcomeMessage", { repName: welcomeData.RepName }) }}</h3>
                </div>
                <div class="panel-body">
                    <div id="divMessage">
                        <label v-html="welcomeData.Message"></label>
                    </div>

                    <div>&nbsp;</div>

                    <div id="divContactSettings">
                        <label><b>{{ $t("message.currentNotificationSettings") }}</b></label><br />
                        <div id="divContactVoice">
                            <label>{{ $t("message.voice") }}</label>
                            <label v-text="welcomeData.Voice"></label>
                        </div>

                        <div id="divContactText">
                            <label>{{ $t("message.text") }}</label>
                            <label v-text="welcomeData.Text"></label>
                        </div>

                        <div id="divContactEmail">
                            <label>{{ $t("message.email") }}</label>
                            <label v-text="welcomeData.Email"></label>
                        </div>

                        <div id="divContactLink">
                            <label>{{ $t("message.welcomePageNotificationMessage") }}</label>
                            <router-link to="/notifications">{{ $t("message.notificationSettingsPage") }}</router-link>
                        </div>
                    </div>

                    <div>&nbsp;</div>

                    <div id="divHomeLink">
                        <router-link to="/home">{{ $t("message.startManagingYourAccount") }}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Welcome',
    data() {
        return {
            welcomeData: {
                RepName: '',
                Message: '',
                Voice: '',
                Text: '',
                Email: ''
            }
        }
    },
    mounted() {
        axios({
            method: "GET",
            url: this.$httpAxiosBaseUrl() + "Welcome/GetWelcomeMessage?date=" + new Date().getTime()
        }).then(result => {
            var response = result.data;
            if (response !== '') {
                this.welcomeData = response;
            } else {
                this.$router.push({ name: "Home" });
            }
        }, error => {
            console.log(error);
        });
    }    
}
</script>

<style scoped>
.panel-welcome {
    margin-top: 10px;
    border-radius: 0;
    border-color: #cecece;
    box-shadow: 0 0 0;
}

    .panel-welcome .panel-body {
        padding: 20px;
    }

    .panel-welcome a:hover {
        color: #2a6496 !important;
    }
</style>